/* Avanti Food (02.11.2026): Mengenrabatt-Kasten im Schnellkauf-Fenster (Desktop).
 * Markup: snippets/af-mengenrabatt-schnellkauf.liquid (wird nur im Schnellkauf-Fenster gezeigt).
 * - Auswahl "1" / "2" setzt die Menge im Fenster.
 * - Aendert der Kunde die Menge selbst, folgt die Auswahl (ab 2 = Rabattstufe).
 * - Bei Groessenwechsel werden die Preise aus data-preise (Cent je Variante) neu gerechnet.
 * Den Rabatt selbst zieht Qikify im Warenkorb ab; hier wird nur angezeigt und die Menge gesetzt.
 */
(function () {
  'use strict';

  function geld(cent) {
    var e = Math.floor(cent / 100);
    var c = cent % 100;
    return '€' + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (c < 10 ? '0' : '') + c;
  }

  function scope(kasten) {
    return kasten.closest('#quick-add-modal-content') || kasten.closest('product-component') || document;
  }

  function mengenFeld(kasten) {
    return scope(kasten).querySelector('input[name="quantity"]');
  }

  function variantenId(kasten) {
    var feld = scope(kasten).querySelector('form[data-type="add-to-cart-form"] input[name="id"], product-form-component input[name="id"]');
    return feld ? String(feld.value) : '';
  }

  function preise(kasten) {
    var liste = {};
    try { liste = JSON.parse(kasten.getAttribute('data-preise') || '{}'); } catch (e) { liste = {}; }
    var id = variantenId(kasten);
    var p = liste[id];
    if (typeof p !== 'number') p = parseInt(kasten.getAttribute('data-preis'), 10) || 0;
    return p;
  }

  function rechnen(kasten) {
    var p = preise(kasten);
    var prozent = parseFloat(kasten.getAttribute('data-prozent')) || 0;
    var ab = parseInt(kasten.getAttribute('data-ab'), 10) || 2;
    var rabatt = Math.round(p * (100 - prozent) / 100);
    var setze = function (sel, text) {
      var el = kasten.querySelector(sel);
      if (el && el.textContent !== text) el.textContent = text;
    };
    setze('[data-af-mr-einzel]', geld(p));
    setze('[data-af-mr-rabatt]', geld(rabatt));
    setze('[data-af-mr-alt]', geld(p));
    setze('[data-af-mr-spar]', 'du sparst ' + geld((p - rabatt) * ab));
  }

  function auswahlNachMenge(kasten) {
    var feld = mengenFeld(kasten);
    if (!feld) return;
    var menge = parseInt(feld.value, 10) || 1;
    var ab = parseInt(kasten.getAttribute('data-ab'), 10) || 2;
    var ziel = menge >= ab ? String(ab) : '1';
    var radio = kasten.querySelector('input[type="radio"][value="' + ziel + '"]');
    if (radio && !radio.checked) radio.checked = true;
  }

  function mengeSetzen(kasten, wert) {
    var feld = mengenFeld(kasten);
    if (!feld) return;
    var ab = parseInt(kasten.getAttribute('data-ab'), 10) || 2;
    var aktuell = parseInt(feld.value, 10) || 1;
    /* Hat der Kunde schon mehr als die Mindestmenge, bei Stufe 2 nichts reduzieren */
    if (wert >= ab && aktuell >= ab) return;
    feld.value = String(wert);
    feld.dispatchEvent(new Event('input', { bubbles: true }));
    feld.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function alle() {
    document.querySelectorAll('.quick-add-modal [data-af-mr]').forEach(function (kasten) {
      rechnen(kasten);
      auswahlNachMenge(kasten);
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    var kasten = t.closest('[data-af-mr]');
    if (kasten && t.type === 'radio') {
      mengeSetzen(kasten, parseInt(t.value, 10) || 1);
      return;
    }
    if (t.closest('.quick-add-modal')) setTimeout(alle, 0);
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t instanceof HTMLInputElement && t.name === 'quantity' && t.closest('.quick-add-modal')) setTimeout(alle, 0);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t instanceof Element && t.closest('.quick-add-modal quantity-selector-component, .quick-add-modal .quantity-selector')) {
      setTimeout(alle, 50);
    }
  });

  function beobachten() {
    var inhalt = document.getElementById('quick-add-modal-content');
    if (!inhalt || !window.MutationObserver) return;
    var geplant = false;
    new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      setTimeout(function () { geplant = false; alle(); }, 30);
    }).observe(inhalt, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beobachten);
  } else {
    beobachten();
  }
})();
